// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2n2QP","location":"Header_location__3kkmN"};